import { Controller } from '@hotwired/stimulus'

const LEVELS = ['log', 'info', 'warn', 'error']

export default class extends Controller {
  static values = {
    message: String,
    level: { type: String, default: 'warn' }
  }

  connect () {
    const level = LEVELS.includes(this.levelValue) ? this.levelValue : 'warn'

    console[level](this.messageValue)
  }
}
